<template>
    <div class="m-agenda-item" :class="'m-agenda-item-theme-' + index">
        <div class="item-wrap"
            :class="{'one-width': data.speaker.length == 1 || data.speaker.length == 0 ,'double-width':data.speaker.length == 2, 'triple-width':data.speaker.length >= 3}">
            <div class="agenda-title"> <span class="t-name">{{ data.time}}</span> </div>
            <div class="a-content">
                <p v-html="data.subject"></p>
                <ul>
                    <li v-for="item in data.speaker">
                        <div class="name-title" v-if="item.name !=' ' && item.name !='  '&& item.name !='   '">
                            <div class="name">{{item.name}}</div>
                            <div class="position">{{item.position}}</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="divider-line"> </div>
        </div>
    </div>
</template>

<script>

export default{
    props:['data','index']
}

</script>

<style lang="scss">
@media screen and (min-width: 280px) {html{font-size:74.6px;}}
@media screen and (min-width: 320px) {html{font-size:85.33px;}}
@media screen and (min-width: 360px) {html{font-size:96px;}}
@media screen and (min-width: 375px) {html{font-size:100px;}}
@media screen and (min-width: 414px) {html{font-size:110.4px;}}
@media screen and (min-width: 440px) {html{font-size:117.33px;}}
@media screen and (min-width: 480px) {html{font-size:128px;}}
@media screen and (min-width: 520px) {html{font-size:138.66px;}}
@media screen and (min-width: 540px) {html{font-size:144px;}}
@media screen and (min-width: 600px) {html{font-size:160px;}}
@media screen and (min-width: 768px) {html{font-size:208.4px;}}

.m-agenda-item{
    color: #fff;
    font-size: .14rem;
    margin-left: .05rem;
    margin-right: .05rem;
    margin-bottom: .1rem;
    vertical-align: top;
    .item-wrap{
        min-height: .16rem;
        .agenda-title{
            color: #342c83;
            .t-name{
                color: #f05050;
                font-size: .15rem;
                height: .2rem;
                line-height: .2rem;
            }
        }
        .a-content{
            // min-height: .6rem;
            p{
                font-size: .16rem;
                line-height: 2;
                font-weight: bold;
            }
            ul{
                li{
                    font-size: .13rem;
                    list-style: none;
                    .name-title{
                        width: 100%;
                        display: inline-block;
                        vertical-align: top;
                        .name, .position{
                            display: inline-block;
                            font-weight: bold;
                            font-size: .14rem;
                        }
                    }
                }
            }
        }
        .divider-line{
            margin-top: 8px;
            width: 100%;
            border-bottom: 1px solid rgba(236, 28, 36, 0.3);
        }
    }
    .one-width{
        max-width: 99%;
    }
    .double-width{
    }
    .triple-width{
    }
    .triple-height{
    }
    &:nth-child(2n) {
        margin-right: 0;
    }
}

</style>



// WEBPACK FOOTER //
// MobileAgendaItem.vue?d7aeffaa